import { environmentDetails } from '@bpd-library/utilities';

import { MapLayerRasterSettings } from '../../store';

const TRANSITION_ZOOM_MARGIN = 0.75;

const raster = (map: mapboxgl.Map, settings: MapLayerRasterSettings) => {
    const accessToken = environmentDetails.mapboxAccessToken || '';
    const tile = `${settings.layerRaster}/{z}/{x}/{y}.png?access_token=${accessToken}`;

    if (map.getSource('raster')) {
        console.warn('Adding multiple layerRasters is not possible');
        return;
    }

    map.addSource('raster', {
        type: 'raster',
        tiles: [tile],
    });

    map.addLayer(
        {
            id: 'raster-image',
            type: 'raster',
            source: 'raster',
            minzoom: 10,
            maxzoom: 24,
        },
        'bridge_minor',
    );

    if (settings.minzoom && settings.maxzoom) {
        setTransitionPaintProperty(map, settings.minzoom, settings.maxzoom);
    }
};

/**
 * @description Creates a fade-in effect when zooming in or out, based on a minzoom and maxzoom
 * @param {string} layer
 * @param {RGBA} color
 * @param {string} property
 * @return {*}
 */
function setTransitionPaintProperty(map: mapboxgl.Map, minzoom: number, maxzoom: number) {
    if (!minzoom || !maxzoom) return;

    map.setPaintProperty('raster-image', 'raster-opacity', [
        'interpolate',
        ['exponential', TRANSITION_ZOOM_MARGIN],
        ['zoom'],
        minzoom - TRANSITION_ZOOM_MARGIN,
        0,
        minzoom,
        1,
        maxzoom,
        1,
        maxzoom + TRANSITION_ZOOM_MARGIN,
        0,
    ]);
}

export default raster;
